import { roster } from 'store/saga/entities/bound';

export const selectRoster = (state, scheduleId) => {
  const entity = roster.select(state, scheduleId);

  return {
    error: entity.error,
    isLoaded: entity.loaded,
    isLoading: entity.loading,
    roster: entity.data || [],
  };
};
